/**
 * Strip common markdown markers for one-line previews (lists, toasts, etc.).
 * Not a full markdown parser — good enough for short UI snippets.
 */
export function markdownToPlain(text) {
  if (text == null) return "";
  return (
    String(text)
      // fenced code blocks → inner text
      .replace(/```[\s\S]*?```/g, (block) =>
        block.replace(/^```[^\n]*\n?/, "").replace(/```$/, "")
      )
      // images / links → label
      .replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1")
      .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
      // headings, blockquotes, list markers
      .replace(/^\s{0,3}#{1,6}\s+/gm, "")
      .replace(/^\s{0,3}>\s?/gm, "")
      .replace(/^\s*([-*+]|\d+\.)\s+/gm, "")
      // emphasis / code / underline (TipTap ++underline++)
      .replace(/(\*\*|__)(.*?)\1/g, "$2")
      .replace(/(\*|_)(.*?)\1/g, "$2")
      .replace(/\+\+([^+]+)\+\+/g, "$1")
      .replace(/`([^`]+)`/g, "$1")
      .replace(/~~(.*?)~~/g, "$1")
      .replace(/[#*_`>~+]/g, "")
      .replace(/\s+/g, " ")
      .trim()
  );
}

/** Plain one-line excerpt with ellipsis when truncated. */
export function plainExcerpt(text, max = 160) {
  const plain = markdownToPlain(text);
  if (!plain) return "";
  if (plain.length <= max) return plain;
  return `${plain.slice(0, max).trim()}…`;
}

export default plainExcerpt;
